let module = angular.module('app.resources');

module.factory('Broadcast', function Broadcast($resource, $q, $http) {
  'ngInject';
  return $resource(
    `${API_ROOT}/account/broadcasts/:id`,
    { id: '@id', simulcast_id: '@simulcast_id' },
    {
      get: {
        method: 'GET',
        transformResponse: (data) => {
          const broadcast = angular.fromJson(data);
          if (!broadcast.content_settings) {
            broadcast.content_settings = {};
          }
          if (!broadcast.metadata) {
            broadcast.metadata = {};
          }
          return broadcast;
        },
      },
      create: {
        method: 'POST',
        url: `${API_ROOT}/account/broadcasts`,
      },
      patch: {
        method: 'PATCH',
      },
      update: {
        method: 'PUT',
      },
      view: {
        method: 'GET',
        url: `${API_ROOT}/account/broadcasts/:id/view`,
      },

      deleteRecurring: {
        method: 'POST',
        url: `${API_ROOT}/account/broadcasts/:id/delete_recurring`,
      },

      // Score here is the actual game/match score
      getScore: {
        method: 'GET',
        url: `${API_ROOT}/account/broadcasts/:id/metadata/scoreboard`,
      },
      saveScore: {
        method: 'PUT',
        url: `${API_ROOT}/account/broadcasts/:id/metadata/scoreboard`,
      },

      scheduleSimulcast: {
        method: 'POST',
        url: `${API_ROOT}/account/broadcasts/:id/simulcast_configuration/:simulcast_id/schedule`,
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/broadcast.js